// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 5618; FWP.get_team, FWP.gfr); hand-edits allowed (see docs/architecture.md)
// PORT: the inline `this.TEAMS_DEF` literal of FWP.init_data_arrays and the FWP.get_team / FWP.gfr helpers it calls were
// PORT: moved here verbatim (only `this.` dropped), so the shared rules module (src/game/rules) can build the table
// PORT: without the Flash runtime; FWP.init_data_arrays and FWP.get_team use these functions.

/** Team colours used by the table: FWP.C_RED .. FWP.C_PURPLE (constant fields of FWP, never reassigned). */
const C_RED = 1;
const C_BLUE = 2;
const C_GREEN = 3;
const C_YELLOW = 4;
const C_PURPLE = 6;

/** FWP.gfr: a CPU team weapon slot with `param1` copies ([0, count, 0 x 9]). */
export function gfr(param1: number): any {
  param1 = Number(param1);
  return [0, param1, 0, 0, 0, 0, 0, 0, 0, 0, 0];
}

/** FWP.get_team: the CPU team of a stage (worms, weapons, perks) for `{ id, cpu_level, worms, color }`. Fresh object per call. */
export function get_team(param1: any): any {
  let _loc3_: any = undefined;
  let _loc4_: any = undefined;
  let _loc5_: any = undefined;
  let _loc6_: any = undefined;
  let _loc7_: any = undefined;
  let _loc8_: any = undefined;
  let _loc9_: any = undefined;
  let _loc10_: any = undefined;
  let _loc11_: any = undefined;
  let _loc12_: any = undefined;
  let _loc13_: any = undefined;
  let _loc14_: any = undefined;
  let _loc15_: any = undefined;
  let _loc16_: any = undefined;
  let _loc17_: any = undefined;
  let _loc2_: any = {};
  _loc2_.worms = param1.worms;
  _loc2_.cpu_level = param1.cpu_level;
  _loc2_.color = param1.color;
  _loc2_.name = param1.id;
  _loc2_.weapons = {};
  if (param1.id == "Рыцари Смерти") {
    _loc2_.weapons = { "bazooka": gfr(100), "grenade": gfr(100) };
    _loc2_.worm1 = {
      "attack": 0,
      "protect": 0,
      "health": 80,
      "spec": 0,
      "perks": {},
      "name": "Толстый Буч"
    };
    _loc2_.worm2 = {
      "attack": 0,
      "protect": 0,
      "health": 80,
      "spec": 0,
      "perks": {},
      "name": "Чайник"
    };
    _loc2_.worm3 = {
      "attack": 0,
      "protect": 0,
      "health": 80,
      "spec": 0,
      "perks": {},
      "name": "Гиена"
    };
    _loc2_.worm4 = {
      "attack": 0,
      "protect": 0,
      "health": 80,
      "spec": 0,
      "perks": {},
      "name": "Громила"
    };
    _loc2_.worm5 = {
      "attack": 0,
      "protect": 0,
      "health": 80,
      "spec": 0,
      "perks": {},
      "name": "Сапожник"
    };
    _loc2_.worm6 = {
      "attack": 0,
      "protect": 0,
      "health": 80,
      "spec": 0,
      "perks": {},
      "name": "Джексон"
    };
  }
  if (param1.id == "Стальной Коготь") {
    _loc2_.weapons = { "bazooka": gfr(100), "grenade": gfr(100), "cluster_bomb": gfr(5) };
    _loc2_.worm1 = {
      "attack": 15,
      "protect": 15,
      "health": 120,
      "spec": 0,
      "perks": {},
      "name": "Папа Джон"
    };
    _loc2_.worm2 = {
      "attack": 15,
      "protect": 15,
      "health": 120,
      "spec": 0,
      "perks": {},
      "name": "Титаник"
    };
    _loc2_.worm3 = {
      "attack": 15,
      "protect": 15,
      "health": 120,
      "spec": 0,
      "perks": {},
      "name": "Мутный"
    };
    _loc2_.worm4 = {
      "attack": 15,
      "protect": 15,
      "health": 120,
      "spec": 0,
      "perks": {},
      "name": "Дерзкий"
    };
    _loc2_.worm5 = {
      "attack": 15,
      "protect": 15,
      "health": 120,
      "spec": 0,
      "perks": {},
      "name": "Четкий"
    };
    _loc2_.worm6 = {
      "attack": 15,
      "protect": 15,
      "health": 120,
      "spec": 0,
      "perks": {},
      "name": "Лезвие"
    };
    _loc2_.worm7 = {
      "attack": 15,
      "protect": 15,
      "health": 120,
      "spec": 0,
      "perks": {},
      "name": "Громила"
    };
  }
  if (param1.id == "Агенты Отражения") {
    _loc2_.weapons = { "unfail_bazooka": gfr(100), "unfail_grenade": gfr(100) };
    _loc2_.worm1 = {
      "attack": 30,
      "protect": 30,
      "health": 180,
      "spec": 0,
      "perks": { "luck": 3, "luck2": 3 },
      "name": "Мистер Смит"
    };
    _loc2_.worm2 = {
      "attack": 30,
      "protect": 30,
      "health": 180,
      "spec": 0,
      "perks": { "luck": 3 },
      "name": "Мистер Локк"
    };
    _loc2_.worm3 = {
      "attack": 30,
      "protect": 30,
      "health": 180,
      "spec": 0,
      "perks": { "luck": 3 },
      "name": "Мистер Ли"
    };
    _loc2_.worm4 = {
      "attack": 30,
      "protect": 30,
      "health": 180,
      "spec": 0,
      "perks": { "luck": 3 },
      "name": "Мистер Форд"
    };
    _loc2_.worm5 = {
      "attack": 30,
      "protect": 30,
      "health": 180,
      "spec": 0,
      "perks": { "luck": 3 },
      "name": "Мистер Браун"
    };
    _loc2_.worm6 = {
      "attack": 30,
      "protect": 30,
      "health": 180,
      "spec": 0,
      "perks": { "luck": 3 },
      "name": "Мистер Бин"
    };
  }
  if (param1.id == "Дети Тьмы") {
    _loc2_.weapons = { "poison_bazooka": gfr(100), "plasma_grenade": gfr(100) };
    _loc2_.worm1 = {
      "attack": 45,
      "protect": 30,
      "health": 220,
      "spec": 0,
      "perks": { "poison_res": 3 },
      "name": "Палейн"
    };
    _loc2_.worm2 = {
      "attack": 45,
      "protect": 30,
      "health": 220,
      "spec": 0,
      "perks": { "poison_res": 3 },
      "name": "Пилинипси 14"
    };
    _loc2_.worm3 = {
      "attack": 45,
      "protect": 30,
      "health": 220,
      "spec": 0,
      "perks": { "poison_res": 3 },
      "name": "Ворсел"
    };
    _loc2_.worm4 = {
      "attack": 45,
      "protect": 30,
      "health": 220,
      "spec": 0,
      "perks": { "poison_res": 3 },
      "name": "Киннисон"
    };
    _loc2_.worm5 = {
      "attack": 45,
      "protect": 30,
      "health": 220,
      "spec": 0,
      "perks": { "poison_res": 3 },
      "name": "Роджер"
    };
  }
  if (param1.id == "Мастера") {
    _loc2_.weapons = {
      "unfail_bazooka": gfr(100),
      "unfail_grenade": gfr(100),
      "fire_bazooka": gfr(5),
      "plasma_grenade": gfr(3),
      "pulse_grenade": gfr(2)
    };
    _loc2_.worm1 = {
      "attack": 75,
      "protect": 75,
      "health": 500,
      "spec": 0,
      "perks": { "crafting": 3, "luck": 3, "luck2": 3, "best_crit": 3 },
      "name": "Костиган"
    };
    _loc2_.worm2 = {
      "attack": 75,
      "protect": 75,
      "health": 410,
      "spec": 0,
      "perks": { "crafting": 3 },
      "name": "Томас"
    };
    _loc2_.worm3 = {
      "attack": 75,
      "protect": 75,
      "health": 410,
      "spec": 0,
      "perks": { "crafting": 3 },
      "name": "Питт"
    };
    _loc2_.worm4 = {
      "attack": 75,
      "protect": 75,
      "health": 410,
      "spec": 0,
      "perks": { "crafting": 3 },
      "name": "Эдиссон"
    };
    _loc2_.worm5 = {
      "attack": 75,
      "protect": 75,
      "health": 410,
      "spec": 0,
      "perks": { "crafting": 3 },
      "name": "Кьюти"
    };
    _loc2_.worm6 = {
      "attack": 75,
      "protect": 75,
      "health": 410,
      "spec": 0,
      "perks": { "crafting": 3 },
      "name": "Флэш"
    };
  }
  if (param1.id == "Взрывники") {
    _loc2_.weapons = {
      "unfail_bazooka": gfr(100),
      "unfail_cluster_bomb": gfr(100),
      "banana_bomb": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": 80,
      "protect": 95,
      "health": 540,
      "spec": 0,
      "perks": { "luck": 3, "luck2": 3, "damage_p": 3, "fire_res": 3 },
      "name": "Тарс Таркас"
    };
    _loc2_.worm2 = {
      "attack": 80,
      "protect": 95,
      "health": 450,
      "spec": 0,
      "perks": { "damage_p": 3, "fire_res": 3 },
      "name": "Би-ес"
    };
    _loc2_.worm3 = {
      "attack": 80,
      "protect": 95,
      "health": 450,
      "spec": 0,
      "perks": { "damage_p": 3, "fire_res": 3 },
      "name": "Динамит"
    };
    _loc2_.worm4 = {
      "attack": 80,
      "protect": 95,
      "health": 450,
      "spec": 0,
      "perks": { "damage_p": 3, "fire_res": 3 },
      "name": "Эми"
    };
    _loc2_.worm5 = {
      "attack": 80,
      "protect": 95,
      "health": 450,
      "spec": 0,
      "perks": { "damage_p": 3, "fire_res": 3 },
      "name": "Спиди"
    };
    _loc2_.worm6 = {
      "attack": 80,
      "protect": 95,
      "health": 450,
      "spec": 0,
      "perks": { "damage_p": 3, "fire_res": 3 },
      "name": "Дирк"
    };
  }
  if (param1.id == "Последователи Грома") {
    _loc2_.weapons = {
      "unfail_bazooka": gfr(100),
      "ap_bazooka": gfr(5),
      "unfail_grenade": gfr(100),
      "pulse_grenade": gfr(5),
      "super_banana_bomb": gfr(1),
      "gauss_pistol": gfr(2)
    };
    _loc2_.worm1 = {
      "attack": 120,
      "protect": 120,
      "health": 650,
      "spec": 0,
      "perks": { "best_crit": 3, "damage_h": 3 },
      "name": "Надрек"
    };
    _loc2_.worm2 = {
      "attack": 100,
      "protect": 100,
      "health": 530,
      "spec": 0,
      "perks": { "damage_h": 3 },
      "name": "Ганнель"
    };
    _loc2_.worm3 = {
      "attack": 100,
      "protect": 100,
      "health": 530,
      "spec": 0,
      "perks": { "damage_h": 3 },
      "name": "Хейнес"
    };
    _loc2_.worm4 = {
      "attack": 100,
      "protect": 100,
      "health": 530,
      "spec": 0,
      "perks": { "damage_h": 3 },
      "name": "Харклерой"
    };
    _loc2_.worm5 = {
      "attack": 100,
      "protect": 100,
      "health": 530,
      "spec": 0,
      "perks": { "damage_h": 3 },
      "name": "Алкон"
    };
    _loc2_.worm6 = {
      "attack": 100,
      "protect": 100,
      "health": 530,
      "spec": 0,
      "perks": { "damage_h": 3 },
      "name": "Кандрон"
    };
  }
  if (param1.id == "Адепты Грома") {
    _loc2_.weapons = {
      "unfail_bazooka": gfr(100),
      "ap_bazooka": gfr(5),
      "unfail_grenade": gfr(100),
      "pulse_grenade": gfr(5),
      "super_banana_bomb": gfr(1),
      "gauss_rifle": gfr(2)
    };
    _loc2_.worm1 = {
      "attack": 130,
      "protect": 125,
      "health": 800,
      "spec": 0,
      "perks": { "heavy_guy": 3, "best_crit": 3, "damage_h": 3 },
      "name": "Кливленд"
    };
    _loc2_.worm2 = {
      "attack": 130,
      "protect": 125,
      "health": 680,
      "spec": 0,
      "perks": { "heavy_guy": 3, "best_crit": 3, "damage_h": 3 },
      "name": "Олмстед"
    };
    _loc2_.worm3 = {
      "attack": 130,
      "protect": 125,
      "health": 680,
      "spec": 0,
      "perks": { "heavy_guy": 3, "best_crit": 3, "damage_h": 3 },
      "name": "Аллердайс"
    };
    _loc2_.worm4 = {
      "attack": 130,
      "protect": 125,
      "health": 680,
      "spec": 0,
      "perks": { "heavy_guy": 3, "best_crit": 3, "damage_h": 3 },
      "name": "Уленгут"
    };
    _loc2_.worm5 = {
      "attack": 130,
      "protect": 125,
      "health": 680,
      "spec": 0,
      "perks": { "heavy_guy": 3, "best_crit": 3, "damage_h": 3 },
      "name": "Бакстер"
    };
    _loc2_.worm6 = {
      "attack": 130,
      "protect": 125,
      "health": 680,
      "spec": 0,
      "perks": { "heavy_guy": 3, "best_crit": 3, "damage_h": 3 },
      "name": "Виллоуби"
    };
  }
  if (param1.id == "Офицеры Отражения") {
    _loc2_.weapons = {
      "ap_bazooka": gfr(100),
      "pulse_grenade": gfr(100),
      "laser_at_rifle": gfr(6),
      "plasma_at_rifle": gfr(5),
      "gauss_pistol": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": 160,
      "protect": 160,
      "health": 1000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 2,
        "damage_h": 2,
        "para_res": 3
      },
      "name": "Бергенхольм"
    };
    _loc2_.worm2 = {
      "attack": 160,
      "protect": 160,
      "health": 900,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 2,
        "damage_h": 2,
        "para_res": 3
      },
      "name": "Родебуш"
    };
    _loc2_.worm3 = {
      "attack": 160,
      "protect": 160,
      "health": 900,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 2,
        "damage_h": 2,
        "para_res": 3
      },
      "name": "Нортроп"
    };
    _loc2_.worm4 = {
      "attack": 100,
      "protect": 100,
      "health": 530,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 2,
        "damage_h": 2,
        "para_res": 3
      },
      "name": "Айзексон"
    };
    _loc2_.worm5 = {
      "attack": 160,
      "protect": 160,
      "health": 900,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 2,
        "damage_h": 2,
        "para_res": 3
      },
      "name": "Морган"
    };
    _loc2_.worm6 = {
      "attack": 160,
      "protect": 160,
      "health": 900,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 2,
        "damage_h": 2,
        "para_res": 3
      },
      "name": "Баскирк"
    };
  }
  if (param1.id == "Элита Отражения" || param1.id == "Элита Отражения 2") {
    _loc3_ = 200;
    _loc4_ = 200;
    _loc5_ = 1400;
    _loc6_ = 1200;
    _loc7_ = 1100;
    _loc8_ = 250;
    _loc9_ = 250;
    _loc10_ = 1500;
    _loc11_ = 1300;
    _loc12_ = 1200;
    _loc13_ = param1.id == "Элита Отражения" ? _loc3_ : _loc8_;
    _loc14_ = param1.id == "Элита Отражения" ? _loc4_ : _loc9_;
    _loc15_ = param1.id == "Элита Отражения" ? _loc5_ : _loc10_;
    _loc16_ = param1.id == "Элита Отражения" ? _loc6_ : _loc11_;
    _loc17_ = param1.id == "Элита Отражения" ? _loc7_ : _loc12_;
    _loc2_.name = "Элита Отражения";
    _loc2_.weapons = {
      "fire_bazooka": gfr(100),
      "pulse_grenade": gfr(100),
      "gauss_rifle": gfr(100),
      "nuclear_bomb": gfr(3),
      "super_banana_bomb": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": _loc13_,
      "protect": _loc14_,
      "health": _loc15_,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "damage_p": 3,
        "damage_h": 3,
        "para_res": 3,
        "fire_res": 3,
        "poison_res": 3
      },
      "name": "Бальтазар"
    };
    _loc2_.worm2 = {
      "attack": _loc13_,
      "protect": _loc14_,
      "health": _loc16_,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 3,
        "damage_h": 3,
        "para_res": 3
      },
      "name": "Скор"
    };
    _loc2_.worm3 = {
      "attack": _loc13_,
      "protect": _loc14_,
      "health": _loc17_,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 3,
        "damage_h": 3,
        "para_res": 3
      },
      "name": "Джапал"
    };
    _loc2_.worm4 = {
      "attack": _loc13_,
      "protect": _loc14_,
      "health": _loc17_,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 3,
        "damage_h": 3,
        "para_res": 3
      },
      "name": "Минтеп"
    };
    _loc2_.worm5 = {
      "attack": _loc13_,
      "protect": _loc14_,
      "health": _loc17_,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 3,
        "damage_h": 3,
        "para_res": 3
      },
      "name": "Кормор"
    };
    _loc2_.worm6 = {
      "attack": _loc13_,
      "protect": _loc14_,
      "health": _loc17_,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 3,
        "damage_h": 3,
        "para_res": 3
      },
      "name": "Анотар"
    };
    _loc2_.worm7 = {
      "attack": _loc13_,
      "protect": _loc14_,
      "health": _loc17_,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 3,
        "damage_h": 3,
        "para_res": 3
      },
      "name": "Пан"
    };
  }
  if (param1.id == "Армия Де Ляметра") {
    _loc2_.weapons = { "rj46": gfr(100), "dl19": gfr(100), "rad_rifle": gfr(100) };
    _loc2_.worm1 = {
      "attack": 300,
      "protect": 300,
      "health": 2000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "para_res": 3,
        "fire_res": 3,
        "poison_res": 3,
        "dmg_thr": 10,
        "god_of_war": 8
      },
      "name": "Заместитель"
    };
    _loc2_.worm2 = {
      "attack": 300,
      "protect": 250,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 5
      },
      "name": "Офицер RD"
    };
    _loc2_.worm3 = {
      "attack": 300,
      "protect": 250,
      "health": 1500,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 5
      },
      "name": "Офицер TS"
    };
    _loc2_.worm4 = {
      "attack": 300,
      "protect": 250,
      "health": 1400,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 5
      },
      "name": "Офицер RT"
    };
    _loc2_.worm5 = {
      "attack": 300,
      "protect": 250,
      "health": 1400,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 5
      },
      "name": "Офицер FS"
    };
    _loc2_.worm6 = {
      "attack": 300,
      "protect": 250,
      "health": 1400,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 5
      },
      "name": "Офицер AJ"
    };
  }
  if (param1.id == "Армия Де Ляметра 2") {
    _loc2_.name = "Армия Де Ляметра";
    _loc2_.weapons = { "multip14": gfr(100), "rainbow_burst": gfr(100), "ec_caws": gfr(100) };
    _loc2_.worm1 = {
      "attack": 300,
      "protect": 300,
      "health": 2200,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "para_res": 3,
        "fire_res": 3,
        "poison_res": 3,
        "dmg_thr": 10,
        "god_of_war": 10
      },
      "name": "Заместитель"
    };
    _loc2_.worm2 = {
      "attack": 300,
      "protect": 300,
      "health": 1800,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 6
      },
      "name": "Офицер RD"
    };
    _loc2_.worm3 = {
      "attack": 300,
      "protect": 300,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 5
      },
      "name": "Офицер TS"
    };
    _loc2_.worm4 = {
      "attack": 300,
      "protect": 300,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 5
      },
      "name": "Офицер RT"
    };
    _loc2_.worm5 = {
      "attack": 300,
      "protect": 300,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 5
      },
      "name": "Офицер FS"
    };
    _loc2_.worm6 = {
      "attack": 300,
      "protect": 300,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 5
      },
      "name": "Офицер AJ"
    };
  }
  if (param1.id == "Армия Де Ляметра 3") {
    _loc2_.name = "Армия Де Ляметра";
    _loc2_.weapons = { "multip17": gfr(100), "infinity_rainbow": gfr(100), "ec_panhammer": gfr(100) };
    _loc2_.worm1 = {
      "attack": 350,
      "protect": 350,
      "health": 2500,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "para_res": 3,
        "fire_res": 3,
        "poison_res": 3,
        "dmg_thr": 10,
        "god_of_war": 10
      },
      "name": "Заместитель"
    };
    _loc2_.worm2 = {
      "attack": 350,
      "protect": 350,
      "health": 1800,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 8
      },
      "name": "Офицер RD"
    };
    _loc2_.worm3 = {
      "attack": 350,
      "protect": 350,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 7
      },
      "name": "Офицер TS"
    };
    _loc2_.worm4 = {
      "attack": 350,
      "protect": 350,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 7
      },
      "name": "Офицер RT"
    };
    _loc2_.worm5 = {
      "attack": 350,
      "protect": 350,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 7
      },
      "name": "Офицер FS"
    };
    _loc2_.worm6 = {
      "attack": 350,
      "protect": 350,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 7
      },
      "name": "Офицер AJ"
    };
    _loc2_.worm7 = {
      "attack": 350,
      "protect": 350,
      "health": 1600,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "fire_res": 3,
        "poison_res": 3,
        "god_of_war": 7
      },
      "name": "Офицер PP"
    };
  }
  if (param1.id == "Легионеры Кентона") {
    _loc2_.weapons = { "multip83": gfr(100), "skyfire": gfr(100), "ec_panhammer": gfr(100) };
    _loc2_.worm1 = {
      "attack": 450,
      "protect": 450,
      "health": 4000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "god_of_war": 10,
        "ap_shots": 3
      },
      "name": "Центурион Милеск"
    };
    _loc2_.worm2 = {
      "attack": 400,
      "protect": 400,
      "health": 2000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 8
      },
      "name": "Гораций Агнеобарб"
    };
    _loc2_.worm3 = {
      "attack": 400,
      "protect": 400,
      "health": 2000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7
      },
      "name": "Квинтилий Метелл"
    };
    _loc2_.worm4 = {
      "attack": 400,
      "protect": 400,
      "health": 2000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7
      },
      "name": "Лукреций Сулла"
    };
    _loc2_.worm5 = {
      "attack": 400,
      "protect": 400,
      "health": 2000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7
      },
      "name": "Сестий Катул"
    };
    _loc2_.worm6 = {
      "attack": 400,
      "protect": 400,
      "health": 2000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7
      },
      "name": "Эмилий Пизон"
    };
  }
  if (param1.id == "Гладиаторы Кентона") {
    _loc2_.weapons = {
      "kenton_bazooka": gfr(100),
      "kenton_grenade": gfr(100),
      "void_melody": gfr(100),
      "emg_teleport": gfr(5)
    };
    _loc2_.worm1 = {
      "attack": 500,
      "protect": 500,
      "health": 5000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "god_of_war": 10,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Парменид"
    };
    _loc2_.worm2 = {
      "attack": 450,
      "protect": 450,
      "health": 2500,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 8,
        "ap_shots": 3
      },
      "name": "Пинарий Сципион"
    };
    _loc2_.worm3 = {
      "attack": 450,
      "protect": 450,
      "health": 2500,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7,
        "ap_shots": 3
      },
      "name": "Геганий Марк"
    };
    _loc2_.worm4 = {
      "attack": 450,
      "protect": 450,
      "health": 2500,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7,
        "ap_shots": 3
      },
      "name": "Муций Лентул"
    };
    _loc2_.worm5 = {
      "attack": 450,
      "protect": 450,
      "health": 2500,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7,
        "ap_shots": 3
      },
      "name": "Ругилий Тавр"
    };
    _loc2_.worm6 = {
      "attack": 450,
      "protect": 450,
      "health": 2500,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7,
        "ap_shots": 3
      },
      "name": "Аквилий Лепид"
    };
  }
  if (param1.id == "Принцы Кентона") {
    _loc2_.weapons = {
      "kenton_bazooka": gfr(100),
      "kenton_grenade": gfr(100),
      "void_melody": gfr(100),
      "emg_teleport": gfr(100)
    };
    _loc2_.worm1 = {
      "attack": 500,
      "protect": 500,
      "health": 5000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "god_of_war": 10,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Перикл"
    };
    _loc2_.worm2 = {
      "attack": 500,
      "protect": 500,
      "health": 4000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 8,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Анаксимен"
    };
    _loc2_.worm3 = {
      "attack": 500,
      "protect": 500,
      "health": 4000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Протагор"
    };
    _loc2_.worm4 = {
      "attack": 500,
      "protect": 500,
      "health": 4000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Маковельский"
    };
    _loc2_.worm5 = {
      "attack": 500,
      "protect": 500,
      "health": 4000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Левкипп"
    };
    _loc2_.worm6 = {
      "attack": 500,
      "protect": 500,
      "health": 4000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Зенон"
    };
    _loc2_.worm7 = {
      "attack": 500,
      "protect": 500,
      "health": 4000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "god_of_war": 7,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Агилион"
    };
  }
  if (param1.id == "Наместник 1") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = { "bazooka": gfr(100), "grenade": gfr(100) };
    _loc2_.worm1 = {
      "attack": 50,
      "protect": 50,
      "health": 200,
      "spec": 0,
      "perks": {},
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 2") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = { "bazooka": gfr(100), "grenade": gfr(100), "cluster_bomb": gfr(5) };
    _loc2_.worm1 = {
      "attack": 75,
      "protect": 75,
      "health": 250,
      "spec": 0,
      "perks": {},
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 3") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = { "unfail_bazooka": gfr(100), "unfail_grenade": gfr(100) };
    _loc2_.worm1 = {
      "attack": 80,
      "protect": 80,
      "health": 300,
      "spec": 0,
      "perks": { "luck": 3, "luck2": 3 },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 4") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = { "unfail_bazooka": gfr(100), "unfail_grenade": gfr(100) };
    _loc2_.worm1 = {
      "attack": 80,
      "protect": 80,
      "health": 400,
      "spec": 0,
      "perks": { "luck": 3, "luck2": 3 },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 5") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = { "poison_bazooka": gfr(100), "plasma_grenade": gfr(100) };
    _loc2_.worm1 = {
      "attack": 100,
      "protect": 100,
      "health": 500,
      "spec": 0,
      "perks": { "poison_res": 3 },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 6") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = {
      "unfail_bazooka": gfr(100),
      "unfail_grenade": gfr(100),
      "fire_bazooka": gfr(5),
      "plasma_grenade": gfr(3),
      "pulse_grenade": gfr(2)
    };
    _loc2_.worm1 = {
      "attack": 125,
      "protect": 125,
      "health": 800,
      "spec": 0,
      "perks": { "crafting": 3, "luck": 3, "luck2": 3, "best_crit": 3 },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 7") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = {
      "unfail_bazooka": gfr(100),
      "unfail_cluster_bomb": gfr(100),
      "banana_bomb": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": 150,
      "protect": 150,
      "health": 1000,
      "spec": 0,
      "perks": { "luck": 3, "luck2": 3, "damage_p": 3, "fire_res": 3 },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 8") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = {
      "unfail_bazooka": gfr(100),
      "ap_bazooka": gfr(5),
      "unfail_grenade": gfr(100),
      "pulse_grenade": gfr(5),
      "super_banana_bomb": gfr(1),
      "gauss_pistol": gfr(2)
    };
    _loc2_.worm1 = {
      "attack": 150,
      "protect": 150,
      "health": 1200,
      "spec": 0,
      "perks": { "best_crit": 3, "damage_h": 3 },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 9") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = {
      "unfail_bazooka": gfr(100),
      "ap_bazooka": gfr(5),
      "unfail_grenade": gfr(100),
      "pulse_grenade": gfr(5),
      "super_banana_bomb": gfr(1),
      "gauss_rifle": gfr(2)
    };
    _loc2_.worm1 = {
      "attack": 160,
      "protect": 160,
      "health": 1500,
      "spec": 0,
      "perks": { "heavy_guy": 3, "best_crit": 3, "damage_h": 3 },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 10") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = {
      "ap_bazooka": gfr(100),
      "pulse_grenade": gfr(100),
      "laser_at_rifle": gfr(6),
      "plasma_at_rifle": gfr(5),
      "gauss_pistol": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": 200,
      "protect": 200,
      "health": 2000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 2,
        "damage_h": 2,
        "para_res": 3
      },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 11") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = {
      "ap_bazooka": gfr(100),
      "pulse_grenade": gfr(100),
      "laser_at_rifle": gfr(6),
      "plasma_at_rifle": gfr(5),
      "gauss_pistol": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": 200,
      "protect": 200,
      "health": 2200,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 2,
        "damage_h": 2,
        "para_res": 3
      },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 12") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = {
      "fire_bazooka": gfr(100),
      "pulse_grenade": gfr(100),
      "gauss_rifle": gfr(100),
      "nuclear_bomb": gfr(3),
      "super_banana_bomb": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": 250,
      "protect": 250,
      "health": 3000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "damage_p": 3,
        "damage_h": 3,
        "para_res": 3,
        "fire_res": 3,
        "poison_res": 3
      },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 13") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = {
      "fire_bazooka": gfr(100),
      "pulse_grenade": gfr(100),
      "gauss_rifle": gfr(100),
      "nuclear_bomb": gfr(3),
      "super_banana_bomb": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": 250,
      "protect": 250,
      "health": 3200,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "damage_p": 3,
        "damage_h": 3,
        "para_res": 3,
        "fire_res": 3,
        "poison_res": 3
      },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 14") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = { "multip14": gfr(100), "rainbow_burst": gfr(100), "ec_caws": gfr(100) };
    _loc2_.worm1 = {
      "attack": 300,
      "protect": 300,
      "health": 3500,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "para_res": 3,
        "fire_res": 3,
        "poison_res": 3,
        "dmg_thr": 10,
        "god_of_war": 10
      },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 15") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = { "multip17": gfr(100), "infinity_rainbow": gfr(100), "ec_panhammer": gfr(100) };
    _loc2_.worm1 = {
      "attack": 400,
      "protect": 400,
      "health": 5000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "para_res": 3,
        "fire_res": 3,
        "poison_res": 3,
        "dmg_thr": 10,
        "god_of_war": 10
      },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 16") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = { "multip83": gfr(100), "skyfire": gfr(100), "ec_panhammer": gfr(100) };
    _loc2_.worm1 = {
      "attack": 450,
      "protect": 450,
      "health": 6000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "god_of_war": 10,
        "ap_shots": 3
      },
      "name": "Наместник"
    };
  }
  if (param1.id == "Наместник 17") {
    _loc2_.name = "Наместник";
    _loc2_.weapons = {
      "kenton_bazooka": gfr(100),
      "kenton_grenade": gfr(100),
      "void_melody": gfr(100),
      "emg_teleport": gfr(5)
    };
    _loc2_.worm1 = {
      "attack": 500,
      "protect": 500,
      "health": 7000,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "god_of_war": 10,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Наместник"
    };
  }
  if (param1.id == "Ополчение") {
    _loc2_.weapons = { "bazooka": gfr(5), "grenade": gfr(5) };
    _loc2_.worm1 = {
      "attack": 0,
      "protect": 0,
      "health": 60,
      "spec": 0,
      "perks": {},
      "name": "Дядя Боб"
    };
    _loc2_.worm2 = {
      "attack": 0,
      "protect": 0,
      "health": 60,
      "spec": 0,
      "perks": {},
      "name": "Валенок"
    };
  }
  if (param1.id == "Главарь Когтя") {
    _loc2_.weapons = {
      "bazooka": gfr(100),
      "grenade": gfr(100),
      "plasma_grenade": gfr(2),
      "sniper_rifle": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": 55,
      "protect": 55,
      "health": 300,
      "spec": 0,
      "perks": { "damage_f": 3 },
      "name": "Большой Джек"
    };
  }
  if (param1.id == "Главарь Детей") {
    _loc2_.weapons = { "poison_bazooka": gfr(100), "pulse_grenade": gfr(100) };
    _loc2_.worm1 = {
      "attack": 80,
      "protect": 80,
      "health": 1500,
      "spec": 0,
      "perks": { "luck": 3, "luck2": 3, "poison_res": 3 },
      "name": "Нерадо"
    };
  }
  if (param1.id == "Главарь Взрывников") {
    _loc2_.weapons = { "beretta": gfr(100) };
    _loc2_.worm1 = {
      "attack": 0,
      "protect": 150,
      "health": 1800,
      "spec": 0,
      "perks": {
        "luck": 3,
        "luck2": 3,
        "damage_p": 3,
        "damage_f": 3,
        "fire_res": 3
      },
      "name": "Лаб Ланед"
    };
  }
  if (param1.id == "Полковник Сэммс") {
    _loc2_.weapons = { "gauss_pistol": gfr(100) };
    _loc2_.worm1 = {
      "attack": 0,
      "protect": 165,
      "health": 2500,
      "spec": 0,
      "perks": { "luck": 3, "luck2": 3, "best_crit": 3, "damage_h": 3 },
      "name": "Вирджил Сэммс"
    };
  }
  if (param1.id == "Повар") {
    _loc2_.weapons = { "fire_bazooka": gfr(100), "unfail_cluster_bomb": gfr(100), "gauss_pistol": gfr(3) };
    _loc2_.worm1 = {
      "attack": 50,
      "protect": 50,
      "health": 1500,
      "spec": 0,
      "perks": { "damage_p": 3, "luck": 3, "luck2": 3, "best_crit": 3 },
      "name": "Повар"
    };
  }
  if (param1.id == "Менигуэн") {
    _loc2_.weapons = {
      "ap_bazooka": gfr(100),
      "plasma_grenade": gfr(100),
      "banana_bomb": gfr(2),
      "sniper_rifle": gfr(100),
      "gauss_rifle": gfr(2)
    };
    _loc2_.worm1 = {
      "attack": 80,
      "protect": 80,
      "health": 3000,
      "spec": 0,
      "perks": { "damage_f": 5, "luck": 3, "luck2": 3, "best_crit": 3 },
      "name": "Менигуэн"
    };
  }
  if (param1.id == "Сайгус") {
    _loc2_.weapons = {
      "ap_bazooka": gfr(100),
      "nuclear_bomb": gfr(2),
      "pulse_grenade": gfr(100),
      "gauss_rifle": gfr(3),
      "rad_rifle": gfr(1)
    };
    _loc2_.worm1 = {
      "attack": 100,
      "protect": 100,
      "health": 6000,
      "spec": 0,
      "perks": {
        "damage_p": 3,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "poison_res": 3
      },
      "name": "Сайгус"
    };
  }
  if (param1.id == "Клод") {
    _loc2_.weapons = {
      "ap_bazooka": gfr(100),
      "nuclear_bomb": gfr(3),
      "pulse_grenade": gfr(100),
      "gauss_rifle": gfr(100),
      "pulse_pistol": gfr(1)
    };
    _loc2_.worm1 = {
      "attack": 150,
      "protect": 125,
      "health": 10000,
      "spec": 0,
      "perks": {
        "damage_p": 3,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 2,
        "poison_res": 3
      },
      "name": "Клод"
    };
  }
  if (param1.id == "Де Ляметр") {
    _loc2_.weapons = {
      "ap_bazooka": gfr(100),
      "nuclear_bomb": gfr(3),
      "pulse_grenade": gfr(100),
      "gauss_rifle": gfr(100),
      "de_lameter": gfr(2)
    };
    _loc2_.worm1 = {
      "attack": 250,
      "protect": 150,
      "health": 15000,
      "spec": 0,
      "perks": {
        "damage_p": 3,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "regeneration": 2,
        "poison_res": 3
      },
      "name": "Де Ляметр"
    };
  }
  if (param1.id == "Мастер-16") {
    _loc2_.weapons = {
      "ap_bazooka": gfr(100),
      "nuclear_bomb": gfr(3),
      "pulse_grenade": gfr(100),
      "rad_rifle": gfr(100),
      "luiston": gfr(3)
    };
    _loc2_.worm1 = {
      "attack": 300,
      "protect": 200,
      "health": 20000,
      "spec": 0,
      "perks": {
        "damage_f": 3,
        "damage_p": 3,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 5,
        "regeneration": 2,
        "poison_res": 3
      },
      "name": "Мастер-16"
    };
  }
  if (param1.id == "Мститель") {
    _loc2_.weapons = {
      "ap_bazooka2": gfr(100),
      "dl19": gfr(100),
      "rad_rifle": gfr(100),
      "de_lameter": gfr(1)
    };
    _loc2_.worm1 = {
      "attack": 350,
      "protect": 275,
      "health": 27000,
      "spec": 0,
      "perks": {
        "damage_f": 3,
        "damage_p": 3,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "poison_res": 3
      },
      "name": "Мститель"
    };
  }
  if (param1.id == "Пилинипси Первый") {
    _loc2_.weapons = { "multip14": gfr(100), "rainbow_burst": gfr(100), "ec_caws": gfr(100) };
    _loc2_.worm1 = {
      "attack": 400,
      "protect": 300,
      "health": 35000,
      "spec": 0,
      "perks": {
        "damage_f": 3,
        "damage_p": 3,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "poison_res": 3
      },
      "name": "Пилинипси I"
    };
  }
  if (param1.id == "Чистильщик") {
    _loc2_.weapons = { "multip17": gfr(100), "infinity_rainbow": gfr(100), "ec_panhammer": gfr(100) };
    _loc2_.worm1 = {
      "attack": 450,
      "protect": 350,
      "health": 42000,
      "spec": 0,
      "perks": {
        "damage_f": 3,
        "damage_p": 3,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "poison_res": 3
      },
      "name": "Чистильщик"
    };
  }
  if (param1.id == "Патриарх") {
    _loc2_.weapons = { "multip17": gfr(100), "infinity_rainbow": gfr(100), "ec_panhammer": gfr(100) };
    _loc2_.worm1 = {
      "attack": 450,
      "protect": 400,
      "health": 48000,
      "spec": 0,
      "perks": {
        "god_of_war": 6,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3
      },
      "name": "Патриарх"
    };
  }
  if (param1.id == "Папа Джеймс") {
    _loc2_.weapons = { "multip83": gfr(100), "skyfire": gfr(100), "ec_panhammer": gfr(100) };
    _loc2_.worm1 = {
      "attack": 500,
      "protect": 500,
      "health": 54000,
      "spec": 0,
      "perks": {
        "god_of_war": 8,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Папа Джеймс"
    };
  }
  if (param1.id == "Принц Дамаскин") {
    _loc2_.weapons = { "kenton_bazooka": gfr(100), "kenton_grenade": gfr(100), "void_melody": gfr(100) };
    _loc2_.worm1 = {
      "attack": 550,
      "protect": 550,
      "health": 60000,
      "spec": 0,
      "perks": {
        "god_of_war": 10,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Дамаскин"
    };
  }
  if (param1.id == "Принц Анаксимандр") {
    _loc2_.weapons = { "kenton_bazooka": gfr(100), "kenton_grenade": gfr(100), "void_melody": gfr(100) };
    _loc2_.worm1 = {
      "attack": 600,
      "protect": 600,
      "health": 65000,
      "spec": 0,
      "perks": {
        "god_of_war": 10,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Анаксимандр"
    };
  }
  if (param1.id == "Принц Алкидамант") {
    _loc2_.weapons = { "kenton_bazooka": gfr(100), "kenton_grenade": gfr(100), "void_melody": gfr(100) };
    _loc2_.worm1 = {
      "attack": 630,
      "protect": 630,
      "health": 72000,
      "spec": 0,
      "perks": {
        "god_of_war": 10,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Алкидамант"
    };
  }
  if (param1.id == "Принц Энесидем") {
    _loc2_.weapons = { "kenton_bazooka": gfr(100), "kenton_grenade": gfr(100), "void_melody": gfr(100) };
    _loc2_.worm1 = {
      "attack": 650,
      "protect": 650,
      "health": 80000,
      "spec": 0,
      "perks": {
        "god_of_war": 10,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Энесидем"
    };
  }
  if (param1.id == "Принц Аркесилай") {
    _loc2_.weapons = { "kenton_bazooka": gfr(100), "kenton_grenade": gfr(100), "void_melody": gfr(100) };
    _loc2_.worm1 = {
      "attack": 675,
      "protect": 675,
      "health": 88000,
      "spec": 0,
      "perks": {
        "god_of_war": 10,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Аркесилай"
    };
  }
  if (param1.id == "Принц Маллансон") {
    _loc2_.weapons = { "kenton_bazooka": gfr(100), "kenton_grenade": gfr(100), "void_melody": gfr(100) };
    _loc2_.worm1 = {
      "attack": 800,
      "protect": 800,
      "health": 130000,
      "spec": 0,
      "perks": {
        "god_of_war": 10,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Маллансон"
    };
  }
  if (param1.id == "Принц Деливрон") {
    _loc2_.weapons = { "kenton_bazooka": gfr(100), "kenton_grenade": gfr(100), "void_melody": gfr(100) };
    _loc2_.worm1 = {
      "attack": 850,
      "protect": 859,
      "health": 200000,
      "spec": 0,
      "perks": {
        "god_of_war": 10,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Деливрон"
    };
  }
  if (param1.id == "Принц Арагон") {
    _loc2_.weapons = { "kenton_bazooka": gfr(100), "kenton_grenade": gfr(100), "void_melody": gfr(100) };
    _loc2_.worm1 = {
      "attack": 900,
      "protect": 900,
      "health": 290000,
      "spec": 0,
      "perks": {
        "god_of_war": 10,
        "luck": 3,
        "luck2": 3,
        "best_crit": 3,
        "dmg_thr": 10,
        "regeneration": 3,
        "ap_shots": 3,
        "absorb": 3
      },
      "name": "Принц Арагон"
    };
  }
  _loc2_.weapons["skip_go"] = gfr(100);
  return _loc2_;
}

/** `this.TEAMS_DEF` literal from FWP.init_data_arrays (stage definitions). Returns a fresh copy on every call (the game mutates it). */
export function create_TEAMS_DEF(): any {
  return {
    "career_max": 100,
    "missions_max": 17,
    "survival_max": 20,
    "boss_max": 19,
    "just1": {
      "teams": 1,
      "level": 1,
      "gold": 0,
      "exp": 0,
      "worm_limit": 8,
      "map": "wormville1",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": ""
    },
    "just2": {
      "teams": 1,
      "level": 1,
      "gold": 0,
      "exp": 0,
      "worm_limit": 8,
      "map": "molivand1",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": ""
    },
    "just3": {
      "teams": 1,
      "level": 1,
      "gold": 0,
      "exp": 0,
      "worm_limit": 8,
      "map": "rolitrad1",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": ""
    },
    "just4": {
      "teams": 1,
      "level": 1,
      "gold": 0,
      "exp": 0,
      "worm_limit": 8,
      "map": "traver1",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": ""
    },
    "just5": {
      "teams": 1,
      "level": 1,
      "gold": 0,
      "exp": 0,
      "worm_limit": 8,
      "map": "sheovar1",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": ""
    },
    "career1": {
      "teams": 1,
      "level": 1,
      "gold": 300,
      "exp": 600,
      "worm_limit": 5,
      "map": "wormville1",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 1 : Новобранец",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 1, "color": C_RED })
    },
    "career2": {
      "teams": 1,
      "level": 1,
      "gold": 320,
      "exp": 650,
      "worm_limit": 5,
      "map": "wormville1",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 2 : Рядовой",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 2, "color": C_RED })
    },
    "career3": {
      "teams": 1,
      "level": 1,
      "gold": 350,
      "exp": 700,
      "worm_limit": 5,
      "map": "wormville2",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 3 : Ефрейтор",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 3, "color": C_RED })
    },
    "career4": {
      "teams": 1,
      "level": 1,
      "gold": 400,
      "exp": 750,
      "worm_limit": 5,
      "map": "wormville2",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 4 : Младший сержант",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 4, "color": C_RED })
    },
    "career5": {
      "teams": 1,
      "level": 1,
      "gold": 400,
      "exp": 900,
      "worm_limit": 5,
      "map": "wormville3",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 5 : Сержант",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 6, "color": C_RED })
    },
    "career6": {
      "teams": 2,
      "level": 1,
      "gold": 450,
      "exp": 950,
      "worm_limit": 5,
      "map": "wormville3",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 6 : Старший сержант",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 2, "color": C_RED }),
      "team3": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 2, "color": C_RED })
    },
    "career7": {
      "teams": 2,
      "level": 1,
      "gold": 500,
      "exp": 1000,
      "worm_limit": 5,
      "map": "wormville4",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 7 : Старшина",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 2, "color": C_RED }),
      "team3": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 3, "color": C_RED })
    },
    "career8": {
      "teams": 2,
      "level": 1,
      "gold": 600,
      "exp": 1100,
      "worm_limit": 5,
      "map": "wormville4",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 8 : Младший лейтенант",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 2, "color": C_RED }),
      "team3": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 4, "color": C_RED })
    },
    "career9": {
      "teams": 2,
      "level": 1,
      "gold": 700,
      "exp": 1150,
      "worm_limit": 5,
      "map": "wormville5",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 9 : Лейтенант",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 2, "color": C_RED }),
      "team3": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 5, "color": C_RED })
    },
    "career10": {
      "teams": 2,
      "level": 1,
      "gold": 800,
      "exp": 1300,
      "worm_limit": 5,
      "map": "wormville5",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 10 : Старший лейтенант",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 2, "color": C_RED }),
      "team3": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 6, "color": C_RED })
    },
    "career11": {
      "teams": 2,
      "level": 1,
      "gold": 900,
      "exp": 1350,
      "worm_limit": 5,
      "map": "wormville2",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 11 : Капитан",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 3, "color": C_GREEN }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 2, "color": C_GREEN })
    },
    "career12": {
      "teams": 2,
      "level": 1,
      "gold": 1000,
      "exp": 1450,
      "worm_limit": 5,
      "map": "wormville3",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 12 : Майор",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 2, "color": C_GREEN }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_GREEN })
    },
    "career13": {
      "teams": 2,
      "level": 1,
      "gold": 1100,
      "exp": 1500,
      "worm_limit": 5,
      "map": "wormville4",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 13 : Подполковник",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 2, "color": C_GREEN }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 5, "color": C_GREEN })
    },
    "career14": {
      "teams": 2,
      "level": 1,
      "gold": 1200,
      "exp": 1550,
      "worm_limit": 5,
      "map": "molivand1",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 14 : Полковник",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 2, "color": C_GREEN }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 6, "color": C_GREEN })
    },
    "career15": {
      "teams": 2,
      "level": 1,
      "gold": 1300,
      "exp": 1700,
      "worm_limit": 5,
      "map": "molivand1",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 15 : Генерал-майор",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 3, "color": C_GREEN }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 6, "color": C_GREEN })
    },
    "career16": {
      "teams": 2,
      "level": 1,
      "gold": 1400,
      "exp": 1750,
      "worm_limit": 5,
      "map": "molivand2",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 16 : Генерал-лейтенант",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_YELLOW }),
      "team3": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 2, "color": C_YELLOW })
    },
    "career17": {
      "teams": 2,
      "level": 1,
      "gold": 1500,
      "exp": 1800,
      "worm_limit": 5,
      "map": "molivand2",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 17 : Генерал-полковник",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_YELLOW }),
      "team3": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "career18": {
      "teams": 2,
      "level": 1,
      "gold": 1550,
      "exp": 1850,
      "worm_limit": 5,
      "map": "molivand3",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 18 : Генерал Армии",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_YELLOW }),
      "team3": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 4, "color": C_YELLOW })
    },
    "career19": {
      "teams": 2,
      "level": 1,
      "gold": 1600,
      "exp": 1900,
      "worm_limit": 5,
      "map": "molivand3",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 19 : Маршал",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_YELLOW }),
      "team3": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 4, "color": C_YELLOW })
    },
    "career20": {
      "teams": 2,
      "level": 1,
      "gold": 1700,
      "exp": 1950,
      "worm_limit": 5,
      "map": "molivand4",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 20 : Генералиссимус",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_YELLOW }),
      "team3": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 5, "color": C_YELLOW })
    },
    "career21": {
      "teams": 3,
      "level": 1,
      "gold": 1800,
      "exp": 2000,
      "worm_limit": 5,
      "map": "molivand4",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 21 : Новобранец FWP Forces",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 2, "color": C_YELLOW }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 2, "color": C_YELLOW }),
      "team4": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 2, "color": C_YELLOW })
    },
    "career22": {
      "teams": 3,
      "level": 1,
      "gold": 1850,
      "exp": 2100,
      "worm_limit": 5,
      "map": "molivand5",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 22 : Рядовой FWP Forces",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 3, "color": C_YELLOW }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 2, "color": C_YELLOW }),
      "team4": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 2, "color": C_YELLOW })
    },
    "career23": {
      "teams": 3,
      "level": 1,
      "gold": 1900,
      "exp": 2150,
      "worm_limit": 5,
      "map": "molivand5",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 23 : Ефрейтор FWP Forces",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 2, "color": C_YELLOW }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 2, "color": C_YELLOW }),
      "team4": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "career24": {
      "teams": 3,
      "level": 1,
      "gold": 2000,
      "exp": 2200,
      "worm_limit": 5,
      "map": "molivand2",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 24 : Младший сержант FWP Forces",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 3, "color": C_YELLOW }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_YELLOW }),
      "team4": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "career25": {
      "teams": 3,
      "level": 1,
      "gold": 2050,
      "exp": 2350,
      "worm_limit": 5,
      "map": "molivand3",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Ранг 25 : Сержант FWP Forces",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 4, "color": C_YELLOW }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_YELLOW }),
      "team4": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "career26": {
      "teams": 2,
      "level": 1,
      "gold": 2100,
      "exp": 2400,
      "worm_limit": 5,
      "map": "rolitrad1",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 26 : Старший сержант FWP Forces",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 4, "color": C_YELLOW }),
      "team3": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 2, "color": C_YELLOW })
    },
    "career27": {
      "teams": 2,
      "level": 1,
      "gold": 2100,
      "exp": 2400,
      "worm_limit": 5,
      "map": "rolitrad1",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 27 : Старшина FWP Forces",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 4, "color": C_YELLOW }),
      "team3": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "career28": {
      "teams": 2,
      "level": 1,
      "gold": 2200,
      "exp": 2500,
      "worm_limit": 5,
      "map": "rolitrad2",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 28 : Младший лейтенант FWP Forces",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 4, "color": C_YELLOW }),
      "team3": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 4, "color": C_YELLOW })
    },
    "career29": {
      "teams": 2,
      "level": 1,
      "gold": 2250,
      "exp": 2550,
      "worm_limit": 5,
      "map": "rolitrad2",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 29 : Лейтенант FWP Forces",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 5, "color": C_YELLOW }),
      "team3": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 5, "color": C_YELLOW })
    },
    "career30": {
      "teams": 2,
      "level": 1,
      "gold": 2300,
      "exp": 2600,
      "worm_limit": 5,
      "map": "rolitrad3",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 30 : Старший лейтенант FWP Forces",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 5, "color": C_YELLOW }),
      "team3": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 6, "color": C_YELLOW })
    },
    "career31": {
      "teams": 2,
      "level": 1,
      "gold": 2350,
      "exp": 2650,
      "worm_limit": 5,
      "map": "rolitrad3",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 31 : Капитан FWP Forces",
      "team2": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 4, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "career32": {
      "teams": 2,
      "level": 1,
      "gold": 2400,
      "exp": 2700,
      "worm_limit": 5,
      "map": "rolitrad4",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 32 : Майор FWP Forces",
      "team2": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 4, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 4, "color": C_YELLOW })
    },
    "career33": {
      "teams": 2,
      "level": 1,
      "gold": 2500,
      "exp": 2750,
      "worm_limit": 5,
      "map": "rolitrad4",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 33 : Подполковник FWP Forces",
      "team2": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 5, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 4, "color": C_YELLOW })
    },
    "career34": {
      "teams": 2,
      "level": 1,
      "gold": 2550,
      "exp": 2800,
      "worm_limit": 5,
      "map": "rolitrad5",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 34 : Полковник FWP Forces",
      "team2": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 5, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 5, "color": C_YELLOW })
    },
    "career35": {
      "teams": 2,
      "level": 1,
      "gold": 2600,
      "exp": 3000,
      "worm_limit": 5,
      "map": "rolitrad5",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 35 : Генерал-майор FWP Forces",
      "team2": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 5, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 6, "color": C_YELLOW })
    },
    "career36": {
      "teams": 2,
      "level": 1,
      "gold": 2700,
      "exp": 3100,
      "worm_limit": 5,
      "map": "rolitrad2",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 36 : Генерал-лейтенант FWP Forces",
      "team2": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 5, "color": C_RED }),
      "team3": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 3, "color": C_RED })
    },
    "career37": {
      "teams": 2,
      "level": 1,
      "gold": 2750,
      "exp": 3150,
      "worm_limit": 5,
      "map": "rolitrad3",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 37 : Генерал-полковник FWP Forces",
      "team2": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 5, "color": C_RED }),
      "team3": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 4, "color": C_RED })
    },
    "career38": {
      "teams": 2,
      "level": 1,
      "gold": 2800,
      "exp": 3200,
      "worm_limit": 5,
      "map": "rolitrad4",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 38 : Генерал Армии FWP Forces",
      "team2": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 5, "color": C_RED }),
      "team3": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 5, "color": C_RED })
    },
    "career39": {
      "teams": 2,
      "level": 1,
      "gold": 2850,
      "exp": 3250,
      "worm_limit": 5,
      "map": "traver1",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 39 : Маршал FWP Forces",
      "team2": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 4, "color": C_RED }),
      "team3": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 6, "color": C_RED })
    },
    "career40": {
      "teams": 2,
      "level": 1,
      "gold": 3000,
      "exp": 3500,
      "worm_limit": 5,
      "map": "traver1",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 40 : Генералиссимус FWP Forces",
      "team2": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 5, "color": C_RED }),
      "team3": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 6, "color": C_RED })
    },
    "career41": {
      "teams": 2,
      "level": 1,
      "gold": 3150,
      "exp": 3550,
      "worm_limit": 5,
      "map": "traver2",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 41 : Новобранец Отражения",
      "team2": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 5, "color": C_RED }),
      "team3": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 2, "color": C_RED })
    },
    "career42": {
      "teams": 2,
      "level": 1,
      "gold": 3250,
      "exp": 3650,
      "worm_limit": 5,
      "map": "traver2",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 42 : Рядовой Отражения",
      "team2": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 5, "color": C_RED }),
      "team3": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 3, "color": C_RED })
    },
    "career43": {
      "teams": 2,
      "level": 1,
      "gold": 3350,
      "exp": 3750,
      "worm_limit": 5,
      "map": "traver3",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 43 : Ефрейтор Отражения",
      "team2": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 5, "color": C_RED }),
      "team3": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 4, "color": C_RED })
    },
    "career44": {
      "teams": 2,
      "level": 1,
      "gold": 3450,
      "exp": 3850,
      "worm_limit": 5,
      "map": "traver3",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 44 : Младший сержант Отражения",
      "team2": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 5, "color": C_RED }),
      "team3": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 5, "color": C_RED })
    },
    "career45": {
      "teams": 2,
      "level": 1,
      "gold": 3500,
      "exp": 4000,
      "worm_limit": 5,
      "map": "traver4",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 45 : Сержант Отражения",
      "team2": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 5, "color": C_RED }),
      "team3": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 6, "color": C_RED })
    },
    "career46": {
      "teams": 2,
      "level": 1,
      "gold": 3550,
      "exp": 4100,
      "worm_limit": 5,
      "map": "traver4",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 46 : Старший сержант Отражения",
      "team2": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 4, "color": C_RED }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 3, "color": C_RED })
    },
    "career47": {
      "teams": 2,
      "level": 1,
      "gold": 3600,
      "exp": 4150,
      "worm_limit": 5,
      "map": "traver5",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 47 : Старшина Отражения",
      "team2": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 4, "color": C_RED }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 4, "color": C_RED })
    },
    "career48": {
      "teams": 2,
      "level": 1,
      "gold": 3700,
      "exp": 4200,
      "worm_limit": 5,
      "map": "traver5",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 48 : Младший лейтенант Отражения",
      "team2": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 3, "color": C_RED }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 5, "color": C_RED })
    },
    "career49": {
      "teams": 2,
      "level": 1,
      "gold": 3800,
      "exp": 4250,
      "worm_limit": 5,
      "map": "traver3",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 49 : Лейтенант Отражения",
      "team2": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 3, "color": C_RED }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 6, "color": C_RED })
    },
    "career50": {
      "teams": 2,
      "level": 1,
      "gold": 3850,
      "exp": 4300,
      "worm_limit": 5,
      "map": "traver4",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "name": "Ранг 50 : Старш. лейтенант Отражения",
      "team2": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 4, "color": C_RED }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 6, "color": C_RED })
    },
    "career51": {
      "teams": 2,
      "level": 1,
      "gold": 4000,
      "exp": 4500,
      "worm_limit": 5,
      "map": "sheovar1",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 51 : Капитан Отражения",
      "team2": get_team({ "id": "Элита Отражения", "cpu_level": 6, "worms": 4, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 6, "color": C_PURPLE })
    },
    "career52": {
      "teams": 2,
      "level": 1,
      "gold": 4100,
      "exp": 4600,
      "worm_limit": 5,
      "map": "sheovar1",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 52 : Майор Отражения",
      "team2": get_team({ "id": "Элита Отражения", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 5, "color": C_PURPLE })
    },
    "career53": {
      "teams": 2,
      "level": 1,
      "gold": 4200,
      "exp": 4750,
      "worm_limit": 5,
      "map": "sheovar2",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 53 : Подполковник Отражения",
      "team2": get_team({ "id": "Элита Отражения", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 4, "color": C_PURPLE })
    },
    "career54": {
      "teams": 2,
      "level": 1,
      "gold": 4300,
      "exp": 4800,
      "worm_limit": 5,
      "map": "sheovar2",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 54 : Полковник Отражения",
      "team2": get_team({ "id": "Элита Отражения", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 6, "color": C_PURPLE })
    },
    "career55": {
      "teams": 2,
      "level": 1,
      "gold": 4500,
      "exp": 5000,
      "worm_limit": 5,
      "map": "sheovar3",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 55 : Генерал-майор Отражения",
      "team2": get_team({ "id": "Элита Отражения", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 5, "color": C_PURPLE })
    },
    "career56": {
      "teams": 2,
      "level": 1,
      "gold": 4600,
      "exp": 5100,
      "worm_limit": 5,
      "map": "sheovar3",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 56 : Генерал-лейтенант Отражения",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 4, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 6, "color": C_PURPLE })
    },
    "career57": {
      "teams": 2,
      "level": 1,
      "gold": 4750,
      "exp": 5250,
      "worm_limit": 5,
      "map": "sheovar4",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 57 : Генерал-полковник Отражения",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 5, "color": C_PURPLE })
    },
    "career58": {
      "teams": 2,
      "level": 1,
      "gold": 4800,
      "exp": 5400,
      "worm_limit": 5,
      "map": "sheovar4",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 58 : Маршал Отражения",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 4, "color": C_PURPLE })
    },
    "career59": {
      "teams": 2,
      "level": 1,
      "gold": 4850,
      "exp": 5500,
      "worm_limit": 5,
      "map": "sheovar5",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 59 : Генералиссимус Отражения",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 6, "color": C_PURPLE })
    },
    "career60": {
      "teams": 2,
      "level": 1,
      "gold": 5000,
      "exp": 5700,
      "worm_limit": 5,
      "map": "sheovar5",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 60 : Новобранец Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 4, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра", "cpu_level": 6, "worms": 4, "color": C_PURPLE })
    },
    "career61": {
      "teams": 2,
      "level": 1,
      "gold": 5500,
      "exp": 6000,
      "worm_limit": 5,
      "map": "sheovar1",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 61 : Рядовой Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра", "cpu_level": 6, "worms": 4, "color": C_PURPLE })
    },
    "career62": {
      "teams": 2,
      "level": 1,
      "gold": 6000,
      "exp": 6500,
      "worm_limit": 5,
      "map": "sheovar2",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 62 : Ефрейтор Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра", "cpu_level": 6, "worms": 4, "color": C_PURPLE })
    },
    "career63": {
      "teams": 2,
      "level": 1,
      "gold": 6300,
      "exp": 7000,
      "worm_limit": 5,
      "map": "sheovar3",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 63 : Мл. сержант Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career64": {
      "teams": 2,
      "level": 1,
      "gold": 6800,
      "exp": 7600,
      "worm_limit": 5,
      "map": "sheovar4",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 64 : Сержант Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 4, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career65": {
      "teams": 2,
      "level": 1,
      "gold": 7100,
      "exp": 8200,
      "worm_limit": 5,
      "map": "sheovar5",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Ранг 65 : Ст. сержант Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career66": {
      "teams": 2,
      "level": 1,
      "gold": 7500,
      "exp": 8500,
      "worm_limit": 5,
      "map": "wormville1",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 66 : Старшина Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career67": {
      "teams": 2,
      "level": 1,
      "gold": 7800,
      "exp": 9000,
      "worm_limit": 5,
      "map": "wormville2",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 67 : Мл. лейтенант Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career68": {
      "teams": 2,
      "level": 1,
      "gold": 8100,
      "exp": 9300,
      "worm_limit": 5,
      "map": "wormville3",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 68 : Лейтенант Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 2", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career69": {
      "teams": 2,
      "level": 1,
      "gold": 8400,
      "exp": 9500,
      "worm_limit": 5,
      "map": "wormville4",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 69 : Ст. лейтенант Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 2", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career70": {
      "teams": 2,
      "level": 1,
      "gold": 8700,
      "exp": 10000,
      "worm_limit": 5,
      "map": "wormville5",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Ранг 70 : Капитан Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career71": {
      "teams": 2,
      "level": 1,
      "gold": 9000,
      "exp": 10200,
      "worm_limit": 5,
      "map": "rolitrad1",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 71 : Майор Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career72": {
      "teams": 2,
      "level": 1,
      "gold": 9300,
      "exp": 10500,
      "worm_limit": 5,
      "map": "rolitrad2",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 72 : Подполковник Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career73": {
      "teams": 2,
      "level": 1,
      "gold": 9500,
      "exp": 10800,
      "worm_limit": 5,
      "map": "rolitrad3",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 73 : Полковник Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career74": {
      "teams": 2,
      "level": 1,
      "gold": 9800,
      "exp": 11100,
      "worm_limit": 5,
      "map": "rolitrad4",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 74 : Генерал-майор Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 7, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career75": {
      "teams": 2,
      "level": 1,
      "gold": 10000,
      "exp": 11600,
      "worm_limit": 5,
      "map": "rolitrad5",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Ранг 75 : Генерал-лейтенант Армии Де Ляметра",
      "team2": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 7, "color": C_PURPLE })
    },
    "career76": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden1",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 76 : Генерал-полковник Армии Де Ляметра",
      "team2": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 2, "color": C_PURPLE })
    },
    "career77": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden1",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 77 : Маршал Армии Де Ляметра",
      "team2": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 3, "color": C_PURPLE })
    },
    "career78": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden2",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 78 : Генералиссимус Армии Де Ляметра",
      "team2": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 4, "color": C_PURPLE })
    },
    "career79": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden2",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 79 : Странник Кентона",
      "team2": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career80": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden3",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 80 : Странник Кентона",
      "team2": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career81": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden3",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 81 : Странник Кентона",
      "team2": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career82": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden4",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 82 : Странник Кентона",
      "team2": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 7, "color": C_PURPLE }),
      "team3": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career83": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden4",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 83 : Странник Кентона",
      "team2": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 3, "color": C_PURPLE }),
      "team3": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 3, "color": C_PURPLE })
    },
    "career84": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden5",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 84 : Странник Кентона",
      "team2": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 4, "color": C_PURPLE }),
      "team3": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 3, "color": C_PURPLE })
    },
    "career85": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden5",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 85 : Странник Кентона",
      "team2": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 4, "color": C_PURPLE }),
      "team3": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 4, "color": C_PURPLE })
    },
    "career86": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden2",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 86 : Странник Кентона",
      "team2": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 4, "color": C_PURPLE })
    },
    "career87": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden3",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 87 : Странник Кентона",
      "team2": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career88": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden4",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 88 : Странник Кентона",
      "team2": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career89": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden5",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Ранг 89 : Странник Кентона",
      "team2": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career90": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden6",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 90 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 3, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "career91": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden6",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 91 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 4, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "career92": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden6",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 92 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 4, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 2, "color": C_PURPLE })
    },
    "career93": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden7",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 93 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 2, "color": C_PURPLE })
    },
    "career94": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden7",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 94 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 2, "color": C_PURPLE })
    },
    "career95": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden7",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 95 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 3, "color": C_PURPLE })
    },
    "career96": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden8",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 96 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 4, "color": C_PURPLE })
    },
    "career97": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden8",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 97 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career98": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden9",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 98 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "career99": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden9",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 99 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE })
    },
    "career100": {
      "teams": 2,
      "level": 1,
      "gold": 11000,
      "exp": 12000,
      "worm_limit": 5,
      "map": "forbidden10",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Ранг 100 : Охотник Кентона",
      "team2": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 6, "color": C_PURPLE }),
      "team3": get_team({ "id": "Принцы Кентона", "cpu_level": 6, "worms": 7, "color": C_PURPLE })
    },
    "survival1": {
      "teams": 1,
      "level": 1,
      "gold": 500,
      "exp": 1000,
      "kills": 5,
      "worm_limit": 5,
      "map": "wormville1",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 1 : Рыцари Смерти (5)",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 2, "color": C_RED })
    },
    "survival2": {
      "teams": 1,
      "level": 1,
      "gold": 600,
      "exp": 1200,
      "kills": 10,
      "worm_limit": 5,
      "map": "wormville1",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 2 : Рыцари Смерти (10)",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 3, "color": C_RED })
    },
    "survival3": {
      "teams": 1,
      "level": 1,
      "gold": 700,
      "exp": 1500,
      "kills": 15,
      "worm_limit": 5,
      "map": "wormville2",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 3 : Рыцари Смерти (15)",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 4, "color": C_RED })
    },
    "survival4": {
      "teams": 1,
      "level": 1,
      "gold": 900,
      "exp": 2000,
      "kills": 25,
      "worm_limit": 5,
      "map": "wormville2",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 4 : Рыцари Смерти (25)",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 5, "color": C_RED })
    },
    "survival5": {
      "teams": 1,
      "level": 1,
      "gold": 1000,
      "exp": 2500,
      "kills": 40,
      "worm_limit": 5,
      "map": "wormville3",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 5 : Рыцари Смерти (40)",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 6, "color": C_RED })
    },
    "survival6": {
      "teams": 1,
      "level": 1,
      "gold": 700,
      "exp": 1500,
      "kills": 10,
      "worm_limit": 5,
      "map": "wormville3",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 6 : Стальной Коготь (10)",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 2, "color": C_RED })
    },
    "survival7": {
      "teams": 1,
      "level": 1,
      "gold": 800,
      "exp": 1700,
      "kills": 15,
      "worm_limit": 5,
      "map": "wormville4",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 7 : Стальной Коготь (15)",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 3, "color": C_RED })
    },
    "survival8": {
      "teams": 1,
      "level": 1,
      "gold": 1000,
      "exp": 2000,
      "kills": 25,
      "worm_limit": 5,
      "map": "wormville4",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 8 : Стальной Коготь (25)",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 4, "color": C_RED })
    },
    "survival9": {
      "teams": 1,
      "level": 1,
      "gold": 1200,
      "exp": 2200,
      "kills": 40,
      "worm_limit": 5,
      "map": "wormville5",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 9 : Стальной Коготь (40)",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 5, "color": C_RED })
    },
    "survival10": {
      "teams": 1,
      "level": 1,
      "gold": 1500,
      "exp": 2500,
      "kills": 60,
      "worm_limit": 5,
      "map": "wormville5",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Этап 10 : Стальной Коготь (60)",
      "team2": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 6, "color": C_RED })
    },
    "survival11": {
      "teams": 1,
      "level": 1,
      "gold": 1200,
      "exp": 2200,
      "kills": 15,
      "worm_limit": 5,
      "map": "molivand1",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 11 : Агенты Отражения (15)",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 2, "color": C_GREEN })
    },
    "survival12": {
      "teams": 1,
      "level": 1,
      "gold": 1500,
      "exp": 2500,
      "kills": 20,
      "worm_limit": 5,
      "map": "molivand1",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 12 : Агенты Отражения (20)",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_GREEN })
    },
    "survival13": {
      "teams": 1,
      "level": 1,
      "gold": 1700,
      "exp": 2700,
      "kills": 30,
      "worm_limit": 5,
      "map": "molivand2",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 13 : Агенты Отражения (30)",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 4, "color": C_GREEN })
    },
    "survival14": {
      "teams": 1,
      "level": 1,
      "gold": 2000,
      "exp": 3000,
      "kills": 40,
      "worm_limit": 5,
      "map": "molivand2",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 14 : Агенты Отражения (40)",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 5, "color": C_GREEN })
    },
    "survival15": {
      "teams": 1,
      "level": 1,
      "gold": 2500,
      "exp": 3800,
      "kills": 60,
      "worm_limit": 5,
      "map": "molivand3",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 15 : Агенты Отражения (60)",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 6, "color": C_GREEN })
    },
    "survival16": {
      "teams": 1,
      "level": 1,
      "gold": 3000,
      "exp": 4000,
      "kills": 20,
      "worm_limit": 5,
      "map": "molivand3",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 16 : Дети Тьмы (20)",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 2, "color": C_YELLOW })
    },
    "survival17": {
      "teams": 1,
      "level": 1,
      "gold": 3300,
      "exp": 4500,
      "kills": 25,
      "worm_limit": 5,
      "map": "molivand4",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 17 : Дети Тьмы (25)",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "survival18": {
      "teams": 1,
      "level": 1,
      "gold": 3600,
      "exp": 4900,
      "kills": 30,
      "worm_limit": 5,
      "map": "molivand4",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 18 : Дети Тьмы (30)",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 4, "color": C_YELLOW })
    },
    "survival19": {
      "teams": 1,
      "level": 1,
      "gold": 4000,
      "exp": 5500,
      "kills": 40,
      "worm_limit": 5,
      "map": "molivand5",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 19 : Дети Тьмы (40)",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 5, "color": C_YELLOW })
    },
    "survival20": {
      "teams": 1,
      "level": 1,
      "gold": 4500,
      "exp": 6000,
      "kills": 60,
      "worm_limit": 5,
      "map": "molivand5",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "name": "Этап 20 : Дети Тьмы (60)",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 6, "color": C_YELLOW })
    },
    "mission1": {
      "teams": 1,
      "level": 3,
      "gold": 700,
      "exp": 1000,
      "worm_limit": 5,
      "map": "mission1",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Миссия 1 : Высадка",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 2, "color": C_RED })
    },
    "mission2": {
      "teams": 2,
      "level": 1,
      "gold": 950,
      "exp": 1200,
      "worm_limit": 5,
      "map": "mission2",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Миссия 2 : Подступы",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 2, "color": C_RED }),
      "team3": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 1, "color": C_RED })
    },
    "mission3": {
      "teams": 2,
      "level": 1,
      "gold": 1000,
      "exp": 1350,
      "worm_limit": 5,
      "map": "mission3",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Миссия 3 : Проблемы в коровнике",
      "team2": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 3, "color": C_RED }),
      "team3": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 2, "color": C_RED })
    },
    "mission4": {
      "teams": 3,
      "level": 1,
      "gold": 1050,
      "exp": 1400,
      "worm_limit": 4,
      "map": "mission4",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Миссия 4 : Вторжение",
      "team2": get_team({ "id": "Ополчение", "cpu_level": 1, "worms": 2, "color": C_BLUE }),
      "team3": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 3, "color": C_RED }),
      "team4": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 3, "color": C_RED })
    },
    "mission5": {
      "teams": 2,
      "level": 1,
      "gold": 1150,
      "exp": 1450,
      "worm_limit": 4,
      "map": "mission5",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Миссия 5 : Главарь",
      "team2": get_team({ "id": "Главарь Когтя", "cpu_level": 2, "worms": 1, "color": C_RED }),
      "team3": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 7, "color": C_RED })
    },
    "mission6": {
      "teams": 1,
      "level": 9,
      "gold": 1200,
      "exp": 1500,
      "worm_limit": 5,
      "map": "mission6",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Миссия 6 : Вход в шахты",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 2, "color": C_GREEN })
    },
    "mission7": {
      "teams": 1,
      "level": 1,
      "gold": 1300,
      "exp": 1650,
      "worm_limit": 5,
      "map": "mission7",
      "bg_type": "caves",
      "bg_mode": "background_cave_mission",
      "water": "normal",
      "name": "Миссия 7 : Продвижение",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 5, "color": C_GREEN })
    },
    "mission8": {
      "teams": 2,
      "level": 1,
      "gold": 1350,
      "exp": 1700,
      "worm_limit": 5,
      "map": "mission8",
      "bg_type": "caves",
      "bg_mode": "background_cave_mission",
      "water": "normal",
      "name": "Миссия 8 : Столкновение",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 3, "color": C_GREEN }),
      "team3": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "mission9": {
      "teams": 1,
      "level": 1,
      "gold": 1600,
      "exp": 1900,
      "worm_limit": 5,
      "map": "mission9",
      "bg_type": "caves",
      "bg_mode": "background_cave_mission",
      "water": "normal",
      "name": "Миссия 9 : Проникновение",
      "team2": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 5, "color": C_YELLOW })
    },
    "mission10": {
      "teams": 2,
      "level": 1,
      "gold": 2000,
      "exp": 2200,
      "worm_limit": 5,
      "map": "mission10",
      "bg_type": "caves",
      "bg_mode": "background_cave_mission",
      "water": "normal",
      "name": "Миссия 10 : Контакт",
      "team2": get_team({ "id": "Главарь Детей", "cpu_level": 4, "worms": 1, "color": C_YELLOW }),
      "team3": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 4, "color": C_YELLOW })
    },
    "mission11": {
      "teams": 1,
      "level": 15,
      "gold": 2100,
      "exp": 2500,
      "worm_limit": 5,
      "map": "mission11",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Миссия 11 : Подступы",
      "team2": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 6, "color": C_GREEN })
    },
    "mission12": {
      "teams": 2,
      "level": 1,
      "gold": 2200,
      "exp": 2600,
      "worm_limit": 5,
      "map": "mission12",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Миссия 12 : Взрывники",
      "team2": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 3, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "mission13": {
      "teams": 2,
      "level": 1,
      "gold": 2300,
      "exp": 2800,
      "worm_limit": 5,
      "map": "mission13",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Миссия 13 : Топливо",
      "team2": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 4, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 3, "color": C_YELLOW })
    },
    "mission14": {
      "teams": 2,
      "level": 1,
      "gold": 2350,
      "exp": 2850,
      "worm_limit": 1,
      "map": "mission14",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Миссия 14 : Кордон",
      "team2": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 2, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 6, "color": C_YELLOW })
    },
    "mission15": {
      "teams": 2,
      "level": 1,
      "gold": 2500,
      "exp": 3000,
      "worm_limit": 3,
      "map": "mission15",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Миссия 15 : Лавина",
      "team2": get_team({ "id": "Главарь Взрывников", "cpu_level": 4, "worms": 1, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 6, "color": C_YELLOW })
    },
    "mission16": {
      "teams": 2,
      "level": 1,
      "gold": 2500,
      "exp": 4500,
      "worm_limit": 2,
      "map": "mission16",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Миссия 16 : Полковник",
      "team2": get_team({ "id": "Полковник Сэммс", "cpu_level": 5, "worms": 1, "color": C_RED }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 5, "worms": 5, "color": C_RED })
    },
    "mission17": {
      "teams": 1,
      "level": 1,
      "gold": 2600,
      "exp": 3100,
      "worm_limit": 3,
      "map": "mission17",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Миссия 17 : Высадка",
      "team2": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 1, "color": C_RED })
    },
    "boss1": {
      "teams": 1,
      "level": 8,
      "gold": 10000,
      "exp": 15000,
      "worm_limit": 5,
      "map": "boss1",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Босс 1 : Повар",
      "team2": get_team({ "id": "Повар", "cpu_level": 5, "worms": 1, "color": C_RED })
    },
    "boss2": {
      "teams": 1,
      "level": 1,
      "gold": 18000,
      "exp": 30000,
      "worm_limit": 5,
      "map": "boss2",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Босс 2 : Менигуэн",
      "team2": get_team({ "id": "Менигуэн", "cpu_level": 5, "worms": 1, "color": C_RED })
    },
    "boss3": {
      "teams": 1,
      "level": 1,
      "gold": 30000,
      "exp": 60000,
      "worm_limit": 5,
      "map": "boss3",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "name": "Босс 3 : Сайгус",
      "team2": get_team({ "id": "Сайгус", "cpu_level": 5, "worms": 1, "color": C_RED })
    },
    "boss4": {
      "teams": 1,
      "level": 1,
      "gold": 50000,
      "exp": 100000,
      "worm_limit": 5,
      "map": "boss4",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Босс 4 : Клод",
      "team2": get_team({ "id": "Клод", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss5": {
      "teams": 1,
      "level": 1,
      "gold": 75000,
      "exp": 150000,
      "worm_limit": 5,
      "map": "boss5",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Босс 5 : Де Ляметр",
      "team2": get_team({ "id": "Де Ляметр", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss6": {
      "teams": 1,
      "level": 1,
      "gold": 100000,
      "exp": 200000,
      "worm_limit": 5,
      "map": "boss6",
      "bg_type": "snow",
      "bg_mode": "background_rolitrad",
      "water": "normal",
      "name": "Босс 6 : Мастер-16",
      "team2": get_team({ "id": "Мастер-16", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss7": {
      "teams": 1,
      "level": 1,
      "gold": 150000,
      "exp": 250000,
      "worm_limit": 5,
      "map": "boss7",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Босс 7 : Мститель",
      "team2": get_team({ "id": "Мститель", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss8": {
      "teams": 1,
      "level": 1,
      "gold": 200000,
      "exp": 300000,
      "worm_limit": 5,
      "map": "boss8",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Босс 8 : Пилинипси Первый",
      "team2": get_team({ "id": "Пилинипси Первый", "cpu_level": 6, "worms": 1, "color": C_YELLOW })
    },
    "boss9": {
      "teams": 1,
      "level": 1,
      "gold": 250000,
      "exp": 350000,
      "worm_limit": 5,
      "map": "boss9",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "name": "Босс 9 : Чистильщик",
      "team2": get_team({ "id": "Чистильщик", "cpu_level": 6, "worms": 1, "color": C_GREEN })
    },
    "boss10": {
      "teams": 1,
      "level": 1,
      "gold": 300000,
      "exp": 400000,
      "worm_limit": 5,
      "map": "boss10",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Босс 10 : Патриарх",
      "team2": get_team({ "id": "Патриарх", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss11": {
      "teams": 1,
      "level": 1,
      "gold": 300000,
      "exp": 400000,
      "worm_limit": 5,
      "map": "boss11",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "name": "Босс 11 : Папа Джеймс",
      "team2": get_team({ "id": "Папа Джеймс", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss12": {
      "teams": 1,
      "level": 1,
      "gold": 300000,
      "exp": 400000,
      "worm_limit": 5,
      "map": "boss12",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Босс 12 : Принц Дамаскин",
      "team2": get_team({ "id": "Принц Дамаскин", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss13": {
      "teams": 1,
      "level": 1,
      "gold": 350000,
      "exp": 450000,
      "worm_limit": 5,
      "map": "boss13",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Босс 13 : Принц Анаксимандр",
      "team2": get_team({ "id": "Принц Анаксимандр", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss14": {
      "teams": 1,
      "level": 1,
      "gold": 350000,
      "exp": 450000,
      "worm_limit": 5,
      "map": "boss12",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Босс 14 : Принц Алкидамант",
      "team2": get_team({ "id": "Принц Алкидамант", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss15": {
      "teams": 1,
      "level": 1,
      "gold": 400000,
      "exp": 500000,
      "worm_limit": 5,
      "map": "boss13",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Босс 15 : Принц Энесидем",
      "team2": get_team({ "id": "Принц Энесидем", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss16": {
      "teams": 1,
      "level": 1,
      "gold": 400000,
      "exp": 500000,
      "worm_limit": 5,
      "map": "boss12",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Босс 16 : Принц Аркесилай",
      "team2": get_team({ "id": "Принц Аркесилай", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss17": {
      "teams": 1,
      "level": 1,
      "gold": 600000,
      "exp": 600000,
      "worm_limit": 5,
      "map": "boss13",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Босс 17 : Принц Маллансон",
      "team2": get_team({ "id": "Принц Маллансон", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss18": {
      "teams": 1,
      "level": 1,
      "gold": 800000,
      "exp": 800000,
      "worm_limit": 5,
      "map": "boss12",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Босс 18 : Принц Деливрон",
      "team2": get_team({ "id": "Принц Деливрон", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "boss19": {
      "teams": 1,
      "level": 1,
      "gold": 1000000,
      "exp": 1000000,
      "worm_limit": 5,
      "map": "boss13",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "name": "Босс 19 : Принц Арагон",
      "team2": get_team({ "id": "Принц Арагон", "cpu_level": 6, "worms": 1, "color": C_PURPLE })
    },
    "assault1": {
      "teams": 2,
      "level": 1,
      "gold": 500,
      "exp": 250,
      "worm_limit": 5,
      "map": "assault1",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "payments": 500,
      "assault_limit": 1000,
      "name": "Рыцари Смерти",
      "team2": get_team({ "id": "Наместник 1", "cpu_level": 1, "worms": 1, "color": C_RED }),
      "team3": get_team({ "id": "Рыцари Смерти", "cpu_level": 1, "worms": 5, "color": C_RED })
    },
    "assault2": {
      "teams": 2,
      "level": 1,
      "gold": 700,
      "exp": 350,
      "worm_limit": 5,
      "map": "assault2",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "payments": 800,
      "assault_limit": 900,
      "name": "Стальной Коготь",
      "team2": get_team({ "id": "Наместник 2", "cpu_level": 2, "worms": 1, "color": C_RED }),
      "team3": get_team({ "id": "Стальной Коготь", "cpu_level": 2, "worms": 5, "color": C_RED })
    },
    "assault3": {
      "teams": 2,
      "level": 1,
      "gold": 800,
      "exp": 400,
      "worm_limit": 5,
      "map": "assault3",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "payments": 1000,
      "assault_limit": 800,
      "name": "Агенты Отражения",
      "team2": get_team({ "id": "Наместник 3", "cpu_level": 3, "worms": 1, "color": C_GREEN }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 5, "color": C_GREEN })
    },
    "assault4": {
      "teams": 2,
      "level": 1,
      "gold": 900,
      "exp": 450,
      "worm_limit": 5,
      "map": "assault4",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "payments": 2000,
      "assault_limit": 700,
      "name": "Агенты Отражения",
      "team2": get_team({ "id": "Наместник 4", "cpu_level": 3, "worms": 1, "color": C_GREEN }),
      "team3": get_team({ "id": "Агенты Отражения", "cpu_level": 3, "worms": 5, "color": C_GREEN })
    },
    "assault5": {
      "teams": 2,
      "level": 1,
      "gold": 1000,
      "exp": 500,
      "worm_limit": 5,
      "map": "assault5",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "payments": 5000,
      "assault_limit": 650,
      "name": "Дети Тьмы",
      "team2": get_team({ "id": "Наместник 5", "cpu_level": 4, "worms": 1, "color": C_YELLOW }),
      "team3": get_team({ "id": "Дети Тьмы", "cpu_level": 4, "worms": 5, "color": C_YELLOW })
    },
    "assault6": {
      "teams": 2,
      "level": 1,
      "gold": 1200,
      "exp": 600,
      "worm_limit": 5,
      "map": "assault6",
      "bg_type": "snow",
      "bg_mode": "background_wormville",
      "water": "normal",
      "payments": 8000,
      "assault_limit": 500,
      "name": "Мастера",
      "team2": get_team({ "id": "Наместник 6", "cpu_level": 4, "worms": 1, "color": C_YELLOW }),
      "team3": get_team({ "id": "Мастера", "cpu_level": 4, "worms": 5, "color": C_YELLOW })
    },
    "assault7": {
      "teams": 2,
      "level": 1,
      "gold": 1400,
      "exp": 700,
      "worm_limit": 5,
      "map": "assault7",
      "bg_type": "snow",
      "bg_mode": "background_wormville",
      "water": "normal",
      "payments": 10000,
      "assault_limit": 450,
      "name": "Взрывники",
      "team2": get_team({ "id": "Наместник 7", "cpu_level": 4, "worms": 1, "color": C_YELLOW }),
      "team3": get_team({ "id": "Взрывники", "cpu_level": 4, "worms": 5, "color": C_YELLOW })
    },
    "assault8": {
      "teams": 2,
      "level": 1,
      "gold": 1600,
      "exp": 800,
      "worm_limit": 5,
      "map": "assault8",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "payments": 11000,
      "assault_limit": 400,
      "name": "Последователи Грома",
      "team2": get_team({ "id": "Наместник 8", "cpu_level": 5, "worms": 1, "color": C_RED }),
      "team3": get_team({ "id": "Последователи Грома", "cpu_level": 5, "worms": 5, "color": C_RED })
    },
    "assault9": {
      "teams": 2,
      "level": 1,
      "gold": 1800,
      "exp": 900,
      "worm_limit": 5,
      "map": "assault9",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "payments": 12000,
      "assault_limit": 350,
      "name": "Адепты Грома",
      "team2": get_team({ "id": "Наместник 9", "cpu_level": 5, "worms": 1, "color": C_RED }),
      "team3": get_team({ "id": "Адепты Грома", "cpu_level": 5, "worms": 5, "color": C_RED })
    },
    "assault10": {
      "teams": 2,
      "level": 1,
      "gold": 2000,
      "exp": 1000,
      "worm_limit": 5,
      "map": "assault10",
      "bg_type": "gulf",
      "bg_mode": "background_traver",
      "water": "normal",
      "payments": 14000,
      "assault_limit": 300,
      "name": "Офицеры Отражения",
      "team2": get_team({ "id": "Наместник 10", "cpu_level": 6, "worms": 1, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "assault11": {
      "teams": 2,
      "level": 1,
      "gold": 2400,
      "exp": 1200,
      "worm_limit": 5,
      "map": "assault11",
      "bg_type": "grass",
      "bg_mode": "background_wormville",
      "water": "normal",
      "payments": 15000,
      "assault_limit": 250,
      "name": "Офицеры Отражения",
      "team2": get_team({ "id": "Наместник 11", "cpu_level": 6, "worms": 1, "color": C_PURPLE }),
      "team3": get_team({ "id": "Офицеры Отражения", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "assault12": {
      "teams": 2,
      "level": 1,
      "gold": 2800,
      "exp": 1400,
      "worm_limit": 5,
      "map": "assault12",
      "bg_type": "caves",
      "bg_mode": "background_molivand",
      "water": "normal",
      "payments": 20000,
      "assault_limit": 200,
      "name": "Элита Отражения",
      "team2": get_team({ "id": "Наместник 12", "cpu_level": 6, "worms": 1, "color": C_PURPLE }),
      "team3": get_team({ "id": "Элита Отражения", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "assault13": {
      "teams": 2,
      "level": 1,
      "gold": 3000,
      "exp": 1600,
      "worm_limit": 5,
      "map": "assault13",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "payments": 25000,
      "assault_limit": 160,
      "name": "Элита Отражения",
      "team2": get_team({ "id": "Наместник 13", "cpu_level": 6, "worms": 1, "color": C_PURPLE }),
      "team3": get_team({ "id": "Элита Отражения 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "assault14": {
      "teams": 2,
      "level": 1,
      "gold": 3500,
      "exp": 1800,
      "worm_limit": 5,
      "map": "assault14",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "payments": 30000,
      "assault_limit": 120,
      "name": "Армия Де Ляметра",
      "team2": get_team({ "id": "Наместник 14", "cpu_level": 6, "worms": 1, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 2", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "assault15": {
      "teams": 2,
      "level": 1,
      "gold": 4000,
      "exp": 2000,
      "worm_limit": 5,
      "map": "assault15",
      "bg_type": "desert",
      "bg_mode": "background_sheovar",
      "water": "normal",
      "payments": 35000,
      "assault_limit": 100,
      "name": "Армия Де Ляметра",
      "team2": get_team({ "id": "Наместник 15", "cpu_level": 6, "worms": 1, "color": C_PURPLE }),
      "team3": get_team({ "id": "Армия Де Ляметра 3", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "assault16": {
      "teams": 2,
      "level": 1,
      "gold": 4500,
      "exp": 2200,
      "worm_limit": 5,
      "map": "assault16",
      "bg_type": "dungeon",
      "bg_mode": "background_forbidden1",
      "water": "normal",
      "payments": 40000,
      "assault_limit": 75,
      "name": "Легионеры Кентона",
      "team2": get_team({ "id": "Наместник 16", "cpu_level": 6, "worms": 1, "color": C_PURPLE }),
      "team3": get_team({ "id": "Легионеры Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    },
    "assault17": {
      "teams": 2,
      "level": 1,
      "gold": 6000,
      "exp": 3000,
      "worm_limit": 5,
      "map": "assault17",
      "bg_type": "kenton",
      "bg_mode": "background_forbidden2",
      "water": "red",
      "payments": 45000,
      "assault_limit": 50,
      "name": "Гладиаторы Кентона",
      "team2": get_team({ "id": "Наместник 17", "cpu_level": 6, "worms": 1, "color": C_PURPLE }),
      "team3": get_team({ "id": "Гладиаторы Кентона", "cpu_level": 6, "worms": 5, "color": C_PURPLE })
    }
  };
}
